import SEO from "@/components/SEO";
import { Eyebrow } from "@/components/Brand";
import { Reveal } from "@/lib/motion";
import { SITE } from "@/lib/site";

const SECTIONS = [
  {
    title: "General information only",
    body: [
      "The information on this website is general in nature and is provided by " + SITE.legalName + " (ABN " + SITE.abn + ") for informational purposes. It does not constitute advice specific to your property or circumstances.",
    ],
  },
  {
    title: "Quotes and pricing",
    body: [
      "Any quotation is subject to an assessment of the property and the proposed installation. Pricing, product availability and specifications may change without notice. Formal installation terms and conditions may be provided separately with your quotation or contract.",
    ],
  },
  {
    title: "Rebates and incentives",
    body: [
      "References to Victorian Energy Upgrades (VEU) incentives on this website are general information only. Rebate eligibility is not guaranteed and depends on current program rules, approved products, existing equipment, installation requirements and property circumstances.",
      "Eligibility must be confirmed before installation. Please see the VEU Rebates page on this website for further information about how eligible incentives are processed.",
      SITE.legalName + " is not affiliated with or endorsed by the Victorian Government.",
    ],
  },
  {
    title: "Warranties",
    body: [
      "Air conditioning equipment is generally covered by the applicable manufacturer's warranty, subject to that manufacturer's terms and conditions. Warranty periods differ between manufacturers and products. Installation-related matters are assessed according to the work performed, the installation contract and applicable consumer law.",
    ],
  },
  {
    title: "Images and illustrations",
    body: [
      "Images on this website may be illustrative and may not depict a specific installation completed by Airconditioning Victoria. Product appearance may vary between models and manufacturers.",
    ],
  },
  {
    title: "Website content",
    body: [
      "We may update, change or remove website content at any time without notice. While we aim to keep information accurate and current, we make no guarantee that all content is complete or error-free.",
    ],
  },
  {
    title: "Intellectual property",
    body: [
      "The content, branding, logo and design of this website are the property of " + SITE.legalName + " or its licensors and may not be reproduced without permission.",
    ],
  },
  {
    title: "Acceptable use",
    body: [
      "You agree not to misuse this website, including by submitting false, misleading or malicious information through website forms, or attempting to interfere with the operation of the site.",
    ],
  },
];

export default function Terms() {
  return (
    <>
      <SEO
        title="Terms & Conditions | Airconditioning Victoria"
        description="Website terms and conditions for Airconditioning Victoria, including quotes, rebates, warranties and acceptable use."
        path="/terms"
      />
      <section className="bg-white py-16 md:py-24" data-testid="terms-page">
        <div className="mx-auto max-w-3xl px-5">
          <Reveal>
            <Eyebrow>Legal</Eyebrow>
            <h1 className="mt-4 font-display text-4xl font-extrabold tracking-tight text-navy sm:text-5xl">
              Terms &amp; Conditions
            </h1>
            <p className="mt-5 text-base leading-relaxed text-mutedblue">
              These terms govern your use of this website. By using this website you accept these
              terms. Formal installation terms and conditions may be provided separately with your
              quotation or contract.
            </p>
          </Reveal>
          <div className="mt-12 space-y-10">
            {SECTIONS.map((s, i) => (
              <Reveal key={s.title} delay={i * 0.03}>
                <section>
                  <h2 className="font-display text-lg font-bold text-navy">{s.title}</h2>
                  {s.body.map((p, j) => (
                    <p key={j} className="mt-3 text-sm leading-relaxed text-mutedblue">
                      {p}
                    </p>
                  ))}
                </section>
              </Reveal>
            ))}
            <Reveal>
              <section className="rounded-[16px] border border-cardline bg-offwhite p-6">
                <h2 className="font-display text-lg font-bold text-navy">Contact</h2>
                <p className="mt-3 text-sm leading-relaxed text-mutedblue">
                  {SITE.legalName} — ABN {SITE.abn}
                  <br />
                  {SITE.address1}, {SITE.address2}
                  <br />
                  Phone:{" "}
                  <a href={SITE.phoneHref} className="text-brand-blue hover:underline" data-testid="terms-phone-link">
                    {SITE.phone}
                  </a>
                  <br />
                  Email:{" "}
                  <a href={SITE.emailHref} className="break-all text-brand-blue hover:underline" data-testid="terms-email-link">
                    {SITE.email}
                  </a>
                </p>
              </section>
            </Reveal>
          </div>
        </div>
      </section>
    </>
  );
}
